import { useFaust } from "../../contexts/FaustContext";
import { ScrollArea } from "../ui/scroll-area";
import { Separator } from "../ui/separator";
import { Badge } from "../ui/badge";
import { MIDIInput } from "../audio/MIDIInput";
import { AudioInput } from "../audio/AudioInput";
import { DSPInfo } from "../audio/DSPInfo";
import { ScopeCanvas } from "../audio/ScopeCanvas";
import { RecorderControls } from "../audio/RecorderControls";
import { OutputButton } from "../audio/OutputButton";

export function RightPanel() {
    const { state } = useFaust();

    return (
        <ScrollArea className="h-full">
            <div className="flex flex-col gap-3 p-3 text-[0.8rem]">
                {/* MIDI Input */}
                <MIDIInput />

                <Separator className="bg-white/[0.08]" />

                {/* Audio Input */}
                <AudioInput />

                <Separator className="bg-white/[0.08]" />

                {/* DSP Info */}
                <DSPInfo />

                {/* Output Scope */}
                {state.hasDsp && (
                    <>
                        <ScopeCanvas type="output" />
                        <Separator className="bg-white/[0.08]" />
                    </>
                )}

                {/* Recorder */}
                <RecorderControls />

                {/* Output Toggle - pushed to bottom */}
                <div className="mt-auto pt-2">
                    <OutputButton />
                </div>
            </div>
        </ScrollArea>
    );
}
